import Vue from 'vue'
import getEnvVars from './getEnvVars'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
const { VERSION, NODE_ENV, ENV } = getEnvVars()

declare global {
  namespace Sentry {
    function init(obj: {
      release: string
      dsn: string
      environment: string
      integrations: any[]
    })

    function addBreadcrumb(obj: {
      category: string
      message: string
      level: string
    })

    function captureException(obj: any)

    class Integrations {
      public static Vue: any
    }
  }
}

export default function initSentry(dsn) {
  if (NODE_ENV === 'production') {
    Sentry.init({
      release: VERSION,
      environment: ENV,
      dsn,
      integrations: [new Integrations.Vue({ Vue })],
    })
  }
}
